import { createContext } from 'react';

const agregarSoliAjusContext = createContext();

export default agregarSoliAjusContext;